/**
 * @file 现货合规墙钩子
 */
import { ready as uniframeReady } from '@/hooks/uniframe';

/**
 * 打开 合规墙 弹窗
 */
export const useComplianceWall = () => {
    const showComplianceWall = (retCode, config) => {
        uniframeReady().then(() => {
            window.BybitUniFrame.ready(({ complianceWall }) => {
                complianceWall.showModal(retCode, config);
            });
        });
    };

    return {
        showComplianceWall,
    };
};
